import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import plant from "../../../../../assets/images/OUR SERVICES/9.Plant on rent.png";
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const PlantOnRent = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Plants On Rent</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <Col lg={6} md={12} className="text-center">
                                    <img src={plant} alt="Plant on Rent Service" className="img-fluid rounded" style={{ width: "100%", height: "auto" }} />
                                </Col>
                                <Col lg={6} md={12}>
                                    <h3 className="fw-bold " style={{ color: "rgb(52, 81, 159)" }}>Plants on Rent</h3>
                                    <p className="text-black">Enhance your workspace with affordable plant rental services.</p>
                                    <p className="text-black">Wide range of indoor and outdoor plants available, including:</p>
                                    <ul className="text-black">
                                        <li><strong>Snake Plant – </strong>Improves air quality and requires minimal maintenance.</li>
                                        <li><strong>Areca Palm – </strong>Adds a lush green touch to offices and commercial spaces.</li>
                                        <li><strong>Money Plant – </strong>Symbolizes good fortune and enhances workspace aesthetics.</li>
                                        <li><strong>Bamboo Plant – </strong>A popular choice for office desks and reception areas.</li>
                                        <li><strong>Ficus Plant – </strong>Provides natural greenery and is perfect for indoor spaces.</li>
                                    </ul>
                                    <p className="text-black">Maintenance and replacement included for hassle-free greenery.</p>
                                    <p className="text-black">Perfect for offices, events, and commercial spaces.</p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default PlantOnRent;